<h4>
    <a [routerLink]="['/posts', post.id]">
        <mat-icon *ngIf="isMale()" svgIcon="male" aria-hidden="false" aria-label="male icon"></mat-icon>
        <mat-icon *ngIf="isFemale()" svgIcon="female" aria-hidden="false" aria-label="female icon"></mat-icon>
        <mat-icon *ngIf="isHongre()" svgIcon="letter-h" aria-hidden="false" aria-label="hongre icon"></mat-icon>
        {{ post.horse.name }}
    </a>
    <div *ngIf="editable" class="actions">
        <button *ngIf="post.status == 'PUBLISHED' && post.almostExpired" class="update" color="primary" mat-mini-fab (click)="renewPost.emit(post)" matTooltip="{{ 'crud.actions.renouvele' | translate }}">
            <mat-icon aria-hidden="false" aria-label="edit post" svgIcon="history"></mat-icon>
        </button>
        <button class="update" color="primary" mat-mini-fab (click)="updatePost.emit(post)" matTooltip="{{ 'crud.actions.update' | translate }}">
            <mat-icon aria-hidden="false" aria-label="edit post" svgIcon="pencil"></mat-icon>
        </button>
        <button class="delete" mat-mini-fab (click)="deletePost.emit(post)" matTooltip="{{ 'crud.actions.delete' | translate }}">
            <mat-icon aria-hidden="false" aria-label="delete post" svgIcon="trash"></mat-icon>
        </button>
    </div>
</h4>
<div class="main-info__sub">
    <span *ngIf="isMale()" class="sex-age">{{ "post.horse.sex.male" | translate }}, {{getAge()}}</span>
    <span *ngIf="isFemale()" class="sex-age">{{ "post.horse.sex.female" | translate }}, {{getAge()}}</span>
    <span *ngIf="isHongre()" class="sex-age">{{ "post.horse.sex.gelding" | translate }}, {{getAge()}}</span>
    <app-status-tag [status]="post.status" *ngIf="editable"></app-status-tag>
</div>
